import React, { useEffect, useState } from "react";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import ReactPaginate from "react-paginate";
import NotFoundData from "../../../../Images/no-data-found.webp";
import BottomMenu from "../../../layout/bottomMenu";
import Calculator from "../../../DistanceCalculator/Calculator";
import MeetingRating from "../../../Rating/Rating";
import { toast } from "react-toastify";
const SmView = ({
match,
  history,
  smDetailsByUserId,
  getSmDetails = [],
  saveRatingForHod,
  ratingByHod = [],
  checkStarForRating,
  getStarCheck = []
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filterInputList, setFilterInputList] = useState([{}]);
  const [open, setOpen] = useState(false);
  const [isFilterRemove, setIsRemoveFilter] = useState(false);
  const [pageNo, setPage] = useState(1);
  const [userId, setUserId] = useState("");
  const [openRatingModel, setOpenRatingModel] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      if(match?.params?.is_rating){
        await smDetailsByUserId(match?.params?.id, 1, match?.params?.is_rating);
      } else {
        await smDetailsByUserId(match?.params?.id, 1);
      }

      setIsLoading(false);
    })();
  }, []);

  console.log(getSmDetails)
  const handleFilter = async (key, value, stringValue = "") => {
    const list = [...filterInputList];
    list[0][key] = value;
    setFilterInputList(list);
  };

  const onPageChange = async (val) => {
    setIsLoading(true);
    if(match?.params?.is_rating){
      await smDetailsByUserId(match?.params?.id, val?.selected + 1, match?.params?.is_rating);
    } else {
      await smDetailsByUserId(match?.params?.id, val?.selected + 1);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    if (
        ratingByHod?.status_code &&
      parseInt(ratingByHod?.status_code) === 200
    ) {
      toast.success("Rating is marked successfully");

      (async () => {
        setOpenRatingModel(false);
        setIsLoading(true);
        // await activityList('lead', match?.params?.id)
        setIsLoading(false);
      })();
    } else if (
        ratingByHod?.status_code &&
      parseInt(ratingByHod?.status_code) !== 200
    ) {
      toast.warning(ratingByHod?.message);
      setOpenRatingModel(false);
    }
  }, [ratingByHod]);

    const handleSubmitFilter = async () => {
      setOpen(false);
      setIsLoading(true);
      await smDetailsByUserId(match?.params?.id, 1, filterInputList);
      setIsLoading(false);
    };

    const handleRemoveFilter = async (key) => {
      // if (key !== "") {
      //   delete filterInputList[0][key];
      //   setFilterInputList(filterInputList);
      //   setIsLoading(true);
      //   if(match?.params?.is_rating){
      //     await smDetailsByUserId(match?.params?.id, filterInputList, match?.params?.is_rating);
      //   } else {
      //     await smDetailsByUserId(match?.params?.id, 1, filterInputList);
      //   }
      //
      //   setIsLoading(false);
      // }
    };

    useEffect(() => {
      (async () => {
        if (isFilterRemove) {
          setFilterInputList([{}]);
          setIsLoading(true);
          if(match?.params?.is_rating){
            await smDetailsByUserId(match?.params?.id, match?.params?.is_rating, pageNo);
          } else {
            await smDetailsByUserId(match?.params?.id, pageNo, "");
          }

          setIsLoading(false);
          setIsRemoveFilter(false);
        }
      })();
    }, [isFilterRemove]);


  return (
    <>
      <Loader isLoading={isLoading} />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Rating Cards"} history={history} />
            <div className="container-fluid common-bg">
              {/*Heading*/}
              <div className="container-fluid bootstrap snippets bg-white">
                
                <>
                {/* Filter View */}
                {filterInputList[0] !== undefined &&
                  Object.keys(filterInputList[0]).length > 0 && (
                    <div className="d-sm-flex align-items-center justify-content-between mb-5">
                      <div className="row pd-filter-div">
                        <div className="col-md-12 col-sm-12 d-flex">
                          <div className="applied-filter">
                            {Object.keys(filterInputList[0]).map((val, i) => {
                              return (
                                <>
                                  <span className="fd-1">
                                    <span
                                      style={{ textTransform: "capitalize" }}
                                    >
                                      {val.replaceAll("_", " ")}
                                    </span>
                                    {" - " + filterInputList[0][val]}
                                    <i
                                      className="bi bi-x-circle"
                                        onClick={(e) => {
                                          handleRemoveFilter(val);
                                        }
                                      }
                                    ></i>
                                  </span>
                                </>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                )}
                {/* Filter View End*/}

                {/* {console.log('sm view:', getSmDetails)} */}
                <div className="row">
                  {/*CARD START*/}
                  {getSmDetails &&
                    getSmDetails?.data !== undefined &&
                    getSmDetails?.data?.data?.map((val, i) => {
                      return (
                        <>
                          <div className="col-md-4 col-sm-6">
                            <div className="card-big-shadow">
                              <div
                                className="card card-just-text"
                                data-background=""
                                data-color=""
                                data-radius="none"
                              >
                                <div className="content">
                                  <h6 className="category mrg-b-12">
                                    <div className="row">
                                      <div
                                        className="col-10"
                                        style={{
                                          color: "#000",
                                          fontSize: "20px",
                                          textAlign: "left",
                                          paddingLeft: "20px",
                                        }}
                                      >
                                      <span className="" >{val?.project_name}</span>
                                      </div>
                                      <div className="col md-2">
                                        <span>
                                          {
                                            (val?.module_type === 'Society' || val?.module_type === 'Corporate' || val?.module_type === 'Mall') ? 
                                              <a href={`/v2-opportunity-activity-view/${val?.id}/1`}>
                                                <i className="bi bi-eye" style={{ fontSize: '20px' }} />
                                              </a>
                                            : <a href={`/view-activity/${val?.id}`}>
                                            <i className="bi bi-eye" style={{ fontSize: '20px' }} />
                                          </a>
                                          }                    
                                        </span>
                                      </div>
                                    </div>
                                    <div className="row list-view mt-4">

                                        <div className="mb-flex">
                                          <div className="col-md-4">
                                            <i
                                              className="fa fa-calendar"
                                              style={{ color: "#970f0f" }}
                                              aria-hidden="true"
                                            ></i>
                                            &nbsp;&nbsp;Meeting Date:
                                          </div>
                                          {val?.meeting_date !== null && (
                                          <div className="col-md-8">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={val?.meeting_date}
                                            >
                                              {val?.meeting_date}
                                            </span>
                                          </div>
                                          )}
                                        </div>
                                      
                                      {/* {val?.purpose_of_visit !== null && val?.purpose_of_visit[0]?.visit_purpose !== null && (
                                        <div className="mb-flex mt-2">
                                          <div className="col-md-6 col-sm-6">
                                            <i
                                              className="fa fa-business-time"
                                              style={{ color: "blue" }}
                                              aria-hidden="true"
                                            ></i>
                                            &nbsp;&nbsp;Purpose:
                                          </div>
                                          <div className="col-md-6 col-sm-6 l2">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={val?.purpose_of_visit[0]?.visit_purpose}
                                            >
                                              {val?.purpose_of_visit[0]?.visit_purpose}
                                            </span>
                                          </div>
                                        </div>
                                      )} */}
                                      {val?.purpose_of_visit !== null && val?.purpose_of_visit.map((visit, index) => (
                                        <div className="mb-flex mt-2" key={index}>
                                          <div className="col-md-6 col-sm-6">
                                            <i
                                              className="fa fa-business-time"
                                              style={{ color: "blue" }}
                                              aria-hidden="true"
                                            ></i>
                                            &nbsp;&nbsp;Purpose:
                                          </div>
                                          <div className="col-md-6 col-sm-6 l2">
                                            <span
                                              className="trigger"
                                              data-tooltip-id={index}
                                              title={visit.visit_purpose}
                                            >
                                              {visit.visit_purpose}
                                            </span>
                                          </div>
                                        </div>
                                      ))}

                                        <div className="mb-flex mt-2">
                                          <div className="col-md-6 col-sm-6">
                                            <i
                                              className="fa fa-star"
                                              style={{ color: "green" }}
                                              aria-hidden="true"
                                            ></i>
                                            &nbsp;&nbsp;Rating from Immediate Senior:
                                          </div>
                                          {val?.rating !== null && val?.rating[0]?.rating !== null && (
                                          <div className="col-md-6 col-sm-6 l2">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={val?.rating[0]?.rating}
                                            >
                                              {val?.rating[0]?.rating}
                                            </span>
                                          </div>
                                          )}
                                        </div>
                                      

                                        <div className="mb-flex mt-2">
                                          <div className="col-md-6 col-sm-6">
                                            <i
                                              className="fa fa-envelope"
                                              style={{ color: "#c98349" }}
                                              aria-hidden="true"
                                            ></i>
                                            &nbsp;&nbsp;Feedback:
                                          </div>
                                          {val?.rating !== null && val?.rating[0]?.remark !== null && (
                                          <div className="col-md-6 col-sm-6 l2">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={val?.rating[0]?.remark}
                                            >
                                              {val?.rating[0]?.remark}
                                            </span>
                                          </div>
                                          )}
                                        </div>
                                      

                                        <div className="mb-flex mt-2">
                                          <div className="col-md-6 col-sm-6">
                                            <i
                                              className="fas fa-file"
                                              style={{ color: "#c98349" }}
                                              aria-hidden="true"
                                            ></i>
                                            &nbsp;&nbsp;MOM:
                                          </div>
                                          {val?.meta_data[0]?.MOM !== null && (
                                          <div className="col-md-6 col-sm-6 l2">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={val?.meta_data[0]?.MOM}
                                            >
                                              {val?.meta_data[0]?.MOM}
                                            </span>
                                          </div>
                                          )}
                                        </div>
                                      
                                    </div>
                                    <hr />
                                  </h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })}
                  {getSmDetails &&
                    getSmDetails?.data !== undefined &&
                    getSmDetails?.data?.data.length > 0 && (
                      <div className="panel-pagination-col panel-table-pagination">
                        <ReactPaginate
                          previousLabel={"<"}
                          nextLabel={">"}
                          breakLabel={"..."}
                          breakClassName={"break-me"}
                          pageCount={
                            getSmDetails?.data?.total /
                            getSmDetails?.data?.per_page
                          }
                          forcePage={
                            getSmDetails?.data?.current_page - 1
                          }
                          pageRangeDisplayed={4}
                          onPageChange={onPageChange}
                          activeClassName={"active"}
                        />
                      </div>
                    )}

                  {getSmDetails &&
                    getSmDetails?.data !== undefined &&
                    getSmDetails?.data?.data?.length === 0 && (
                      <>
                        <img
                          src={NotFoundData}
                          className="not-found-data"
                          alt={""}
                        />
                        <div className="text-center" style={{ width: "100%" }}>
                          Data Not Found
                        </div>
                      </>
                )}
                </div>
                </>
                
              </div>
            </div>
          </div>
        </div>

        <BottomMenu
          open={open}
          setOpen={setOpen}
          handleSubmitFilter={handleSubmitFilter}
          filterContent={{data:[
            {'field' :'text', 'place_holder' : 'Name', 'values' : ''},
            {'field' : 'dropdown', 'place_holder' : 'Rating', 'values' : [{'id' : 1, 'name' : '1'}, {'id' : 2, 'name' : '2'}, {'id' : 3, 'name' : '3'},  {'id' : 4, 'name' : '4'},  {'id' : 5, 'name' : '5'}]},
        ]}}
          handleFilter={handleFilter}
          setIsRemoveFilter={setIsRemoveFilter}
        />
        
      </div>
      {/* section ends */}
    </>
  );
};

export default SmView;
